import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import MobileNavBar from './components/Layout/MobileNavBar';
import './App.css';

const Home = React.lazy(() => import('./pages/Home'));
const Shop = React.lazy(() => import('./pages/Shop'));
const ProductDetails = React.lazy(() => import('./pages/ProductDetails'));
const Cart = React.lazy(() => import('./pages/Cart'));
const Checkout = React.lazy(() => import('./pages/Checkout'));
const GuestCheckout = React.lazy(() => import('./pages/GuestCheckout'));
const GuestOrderTracking = React.lazy(() => import('./pages/GuestOrderTracking'));
const OrderSuccess = React.lazy(() => import('./pages/OrderSuccess'));
const Login = React.lazy(() => import('./pages/Login'));
const Register = React.lazy(() => import('./pages/Register'));
const ForgotPassword = React.lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./pages/ResetPassword'));
const Profile = React.lazy(() => import('./pages/Profile'));
const Orders = React.lazy(() => import('./pages/Orders'));
const Wishlist = React.lazy(() => import('./pages/Wishlist'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const TermsAndConditions = React.lazy(() => import('./pages/TermsAndConditions'));
const RefundPolicy = React.lazy(() => import('./pages/RefundPolicy'));
const ShippingPolicy = React.lazy(() => import('./pages/ShippingPolicy'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));


function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <React.Suspense fallback={<div className="loading"><div className="spinner"></div></div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetails />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/guest-checkout" element={<GuestCheckout />} />
              <Route path="/guest-order-tracking" element={<GuestOrderTracking />} />
              <Route path="/track-order" element={<GuestOrderTracking />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<Orders />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/contact-us" element={<ContactUs />} />
            </Routes>
          </React.Suspense>
        </main>
        <Footer />
        <MobileNavBar />
      </div>
    </Router>
  );
}

export default App;
